import React, { useEffect, useState } from 'react';
import checked from './../../../../assets/icons/checked.png'
import { uploadFiles } from './../../../../fileUploader/FileUploader';
import pending from './../../../../assets/icons/pending.png'
import { ToastContainer, toast } from 'react-toastify';
import upload from './../../../../assets/icons/cloud-computing.png'
import CloseIcon from '@mui/icons-material/Close';

import {
    Input,
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
    Tooltip,
    tooltipClasses,
    Typography,
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material/styles'

function CourierDocuments(props) {

    const [tableData, setTableData] = useState([
        {
            Id: '12233445',
            CourierDocumentsId: '',
            Name: 'Company information',
            Description: 'One of: Passport, valid driving license, National ID',
            File: [],
            Comment: 'comment',
        },
        {
            Id: '12233445',
            CourierDocumentsId: '',
            Name: 'Valid driving license',
            Description: 'One of: valid driving license',
            File: [],
            Comment: 'comment',
        },
        {
            Id: '12233445',
            CourierDocumentsId: '',
            Name: 'Right to work proof',
            Description: 'One of: Passport, National ID',
            File: [],
            Comment: 'comment',
        },
        {
            Id: '12233445',
            CourierDocumentsId: '',
            Name: 'Address verification',
            Description: 'One of: Personal bank statement. must match payment details field if sole trader',
            File: [],
            Comment: 'comment',
        },
        {
            Id: '12233445',
            CourierDocumentsId: '',
            Name: 'Business bank statement ',
            Description: 'One of: Company bank statement matching payment details',
            File: [],
            Comment: 'comment',
        },
        {
            Id: '12233445',
            CourierDocumentsId: '',
            Name: 'Insurance documents proof ',
            Description: 'One of: Insurance documents',
            File: [],
            Comment: 'comment',
        }

    ]);
    const isFileSizeValid = (file, maxSizeInBytes) => {
        if (file && file.size <= maxSizeInBytes) {
            return file;
        }

    };

    // useEffect(() => {
    //     if (props.DeliverVehiclevalue == "MotoBike" || props.DeliverVehiclevalue == "Car") {
    //         // setTableData((prevData) => [...prevData, newObj]);
    //     }
    //     console.log(tableData);
    // }, [props.DeliverVehiclevalue])

    const [CompanyInfoFiles, setCompanyInfoFiles] = useState([]);
    const handleCompanyInfoFileChange = (event, data) => {
        var valid = true;
        const files = event.target.files[0]

        const maxSizeInBytes = 50 * 1024 * 1024;

        if (isFileSizeValid(files, maxSizeInBytes)) {
            data.File.push(files)
            // props.parentData(tableData)
            props.parentData(tableData)
            setCompanyInfoFiles([...CompanyInfoFiles, ...event.target.files]);
        } else {

            valid = false;
            toast.error("File size should be less than or equal to 50 MB", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        console.log(tableData);
    }
    const [ValidDrivingFiles, setValidDrivingFiles] = useState([]);
    const handleValidDrivingFileChange = (event) => {

        var valid = true;
        const files = event.target.files[0];
        const maxSizeInBytes = 50 * 1024 * 1024;

        if (isFileSizeValid(files, maxSizeInBytes)) {
            tableData[1].File.push(files);
            props.parentData(tableData);
            setValidDrivingFiles([...ValidDrivingFiles, ...event.target.files]);
        } else {

            // alert("File size should be less than or equal to 50 MB.");
            valid = false;
            toast.error("File size should be less than or equal to 50 MB", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        console.log(tableData);

    };
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const [obj, setObj] = useState({
        Id: '12233445',
        CourierDocumentsId: '',
        Name: '',
        Description: '',
        File: [],
        Comment: 'comment'
    })
    const handleNameChange = (event) => {
        setObj((prevObj) => ({ ...prevObj, Name: event.target.value }));
    }
    const handleDescriptionChange = (event) => {
        setObj((prevObj) => ({ ...prevObj, Description: event.target.value }));
    }
    const handleCommentChange = (event) => {
        setObj((prevObj) => ({ ...prevObj, Comment: event.target.value }));
    }
    const [selectedFiles, setSelectedFiles] = useState([]);
    const handleFileChange = (event) => {
        const files = event.target.files;

        setSelectedFiles([...selectedFiles, ...files]);
    };
    useEffect(() => {

        setObj((prevObj) => ({ ...prevObj, File: selectedFiles }));

    }, [selectedFiles]);
    const onAdd = () => {
        var valid = true;
        if (obj.Name === '' || obj.Description === '' || obj.File.length === 0) {
            console.log(obj.Name);
            console.log(obj.Description);
            console.log(obj.File.length);
            valid = false;
            toast.error("Name, Description & File must be inserted", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else {



            const newObj = {
                Id: '12233445',
                CourierDocumentsId: obj.CourierDocumentsId,
                Name: obj.Name,
                Description: obj.Description,
                File: obj.File,
                Comment: obj.Comment,
            };
            setTableData((prevData) => [...prevData, newObj]);
            props.parentData(tableData)
            // setParent(!parent)
            setSelectedFiles([])
            setOpen(false)

        }
    }

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 320,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));


    return (
        <div>


            <Dialog

                open={open}
                onClose={handleClose}

            >
                <div className='dialogColor'>
                    <Grid className='d-flex justify-content-between'>
                        <DialogTitle>
                            Add document

                        </DialogTitle>
                        <DialogActions>
                            <Button onClick={handleClose}><CloseIcon /></Button>
                        </DialogActions>
                    </Grid>
                    <DialogContent>
                        <Grid xs={12} className='nameTextarea'>
                            <TextField fullWidth id="outlined-basic" label="Name" variant="filled"
                                onChange={handleNameChange} />
                        </Grid>
                        <Grid xs={12} className='pt-3 descriptionText'>
                            <TextField
                                fullWidth
                                id="outlined-multiline-static"
                                label="Description"
                                multiline
                                rows={4}
                                // defaultValue="Default Value"
                                variant="filled"
                                onChange={handleDescriptionChange}
                            />
                        </Grid>
                        <Grid xs={12}>
                            <div className='pt-3'>
                                <Input
                                    type="file"
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                    id="file-uploader"
                                />

                                <label htmlFor="file-uploader" className='dotted-border'>

                                    Upload
                                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                                </label>

                                {selectedFiles.length > 0 && (
                                    <div>

                                        <ul >
                                            {selectedFiles.map((file, index) => (

                                                <li key={index}>{file.name}</li>

                                            ))}
                                        </ul>
                                    </div>
                                )}


                            </div>
                        </Grid>
                        <Grid xs={12} className='pt-3 descriptionText'>
                            <TextField
                                fullWidth
                                id="outlined-multiline-static"
                                label="Type comment (optional)"
                                multiline
                                rows={4}
                                // defaultValue="Default Value"
                                variant="filled"
                                onChange={handleCommentChange}
                            />
                        </Grid>
                        <Grid xs={12} className='pt-3'>
                            <div className='add-cancel d-flex  justify-content-between'>
                                <button className='buttonWidth'>Cancel</button>
                                <button className='buttonWidth buttonWidthAdd' onClick={onAdd}>Add</button>
                            </div>
                        </Grid>
                    </DialogContent>
                </div>
            </Dialog>


            <Grid xs={12}>
                <table className=' mt-4' style={{ width: '100%' }}>
                    <tr>
                        <th>Name</th>
                        <th>Status</th>
                        <th>Documents</th>

                    </tr>
                    {
                        tableData.map((dt, i) => {
                            return (

                                dt.Name == "Valid driving license" || dt.Name == "Insurance documents proof " ? (
                                    props.carSelection || props.motorbikeSelection ? (
                                        <tr>
                                            <td >
                                                <div className='d-flex' style={{ gap: "10px" }}>
                                                    <h6> {dt.Name}*</h6>
                                                    {
                                                        dt.Name == "Insurance documents proof " ? (
                                                            <HtmlTooltip
                                                                title={
                                                                    <React.Fragment>
                                                                        <Typography color="inherit">Please upload an image of your Certificate of Motor Insurance that covers you for food delivery (note: we do not accept a schedule of motor insurance, or policy schedule). Please also ensure the following: - Information on the document must be clearly legible with all borders, information and logos visible - The name on the document must match the name on your driving licence - Your insurance must cover you for food delivery (please check with your provider) - There should be no express exclusions of cover for commercial hire and reward or delivery activity - The document must be current and not expired - If your name is not on the document, please upload a picture of the Certificate of Motor Insurance and the permission letter in the same image</Typography>
                                                                    </React.Fragment>
                                                                }>
                                                                <InfoOutlinedIcon style={{ color: '#371B17' }} />
                                                            </HtmlTooltip>
                                                        ) : ("")
                                                    }

                                                </div>

                                                <p className='tableDescription'>
                                                    {dt.Description}
                                                </p>
                                            </td>
                                            <td >
                                                {dt.File.length != 0 ?
                                                    <div className='d-flex'>

                                                        <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                                                        <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                                                    </div> :
                                                    <div className='d-flex'>

                                                        <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                                                        <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                                                    </div>
                                                }

                                            </td>
                                            <td>
                                                <div className='pt-3'>


                                                    <Input
                                                        type="file"
                                                        onChange={(event) => { handleCompanyInfoFileChange(event, dt) }}
                                                        style={{ display: 'none' }}
                                                        id={dt.Name}
                                                    />

                                                    {dt.File.length > 0 && (
                                                        <div>

                                                            <ul className='dotted-border-forfiles d-flex flex-column'>
                                                                {dt.File.map((file, index) => (

                                                                    <li key={index}>{file.name}</li>

                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )}
                                                    <label htmlFor={dt.Name} className='uploadText'>

                                                        Upload
                                                        <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                                                    </label>



                                                </div>
                                            </td>
                                        </tr>
                                    ) : ("")

                                ) : (
                                    <tr>
                                        <td >
                                            <div className='d-flex' style={{ gap: "10px" }}>
                                                <h6> {dt.Name}*</h6>
                                                {
                                                    dt.Name == "Insurance documents proof " ? (
                                                        <HtmlTooltip
                                                            title={
                                                                <React.Fragment>
                                                                    <Typography color="inherit">Please upload an image of your Certificate of Motor Insurance that covers you for food delivery (note: we do not accept a schedule of motor insurance, or policy schedule). Please also ensure the following: - Information on the document must be clearly legible with all borders, information and logos visible - The name on the document must match the name on your driving licence - Your insurance must cover you for food delivery (please check with your provider) - There should be no express exclusions of cover for commercial hire and reward or delivery activity - The document must be current and not expired - If your name is not on the document, please upload a picture of the Certificate of Motor Insurance and the permission letter in the same image</Typography>
                                                                </React.Fragment>
                                                            }>
                                                            <InfoOutlinedIcon style={{ color: '#371B17' }} />
                                                        </HtmlTooltip>
                                                    ) : ("")
                                                }

                                            </div>

                                            <p className='tableDescription'>
                                                {dt.Description}
                                            </p>
                                        </td>
                                        <td >
                                            {dt.File.length != 0 ?
                                                <div className='d-flex'>

                                                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                                                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                                                </div> :
                                                <div className='d-flex'>

                                                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                                                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                                                </div>
                                            }

                                        </td>
                                        <td>
                                            <div className='pt-3'>


                                                <Input
                                                    type="file"
                                                    onChange={(event) => { handleCompanyInfoFileChange(event, dt) }}
                                                    style={{ display: 'none' }}
                                                    id={dt.Name}
                                                />

                                                {dt.File.length > 0 && (
                                                    <div>

                                                        <ul className='dotted-border-forfiles d-flex flex-column'>
                                                            {dt.File.map((file, index) => (

                                                                <li key={index}>{file.name}</li>

                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                                <label htmlFor={dt.Name} className='uploadText'>

                                                    Upload
                                                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                                                </label>



                                            </div>
                                        </td>
                                    </tr>
                                )


                            )
                        })
                    }


                </table>
            </Grid>
            <div className='mt-3 d-flex  align-items-center' style={{ gap: "10px" }}>
                <Button variant="contained" className='UploadButton' onClick={handleClickOpen}>+ Add document</Button>
                <span className='additionalText'>Please note that adding additional document can significantly decreases reviewing time.</span>
            </div>
        </div>
    );
}

export default CourierDocuments;